export default "__VITE_ASSET__BHCU417$__"